import { useEffect, useState } from "react";
import { HEADER } from "@/constants/testIds";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Story", href: "/#story", id: HEADER.navStory },
  { label: "Products", href: "/#products", id: HEADER.navProducts },
  { label: "Origin", href: "/#origin", id: HEADER.navOrigin },
  { label: "Journey", href: "/#journey", id: HEADER.navJourney },
  { label: "Contact", href: "/#contact", id: HEADER.navContact },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid={HEADER.wrapper}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#faf7f2]/85 backdrop-blur-xl border-b border-[#1a3626]/8 shadow-[0_4px_30px_rgba(26,54,38,0.04)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 flex items-center justify-between h-16 sm:h-20">
        <a
          data-testid={HEADER.logo}
          href="#top"
          className="flex items-center gap-3 group"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_cashew-origin-story/artifacts/try0erao_image.png"
            alt="NAIJA Cashews logo"
            className="w-10 h-10 sm:w-11 sm:h-11 object-contain shrink-0 drop-shadow-[0_4px_10px_rgba(26,54,38,0.18)]"
          />
          <span className="flex flex-col leading-none">
            <span className="font-serif-display text-[18px] sm:text-[20px] text-[#1a3626] tracking-tight">
              NAIJA Cashews
            </span>
            <span className="hidden sm:block text-[10px] tracking-[0.22em] uppercase text-[#8b5a2b]/80 mt-1">
              Natural · Nutritious · Nigerian
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.id}
              data-testid={n.id}
              href={n.href}
              className="text-[13px] tracking-wide text-[#1a3626]/80 hover:text-[#1a3626] transition-colors relative group"
            >
              {n.label}
              <span className="absolute left-0 -bottom-1 h-px w-0 bg-[#c5a059] group-hover:w-full transition-all duration-500" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid={HEADER.shopBtn}
            href="/#signup"
            className="hidden sm:inline-flex items-center gap-2 bg-[#1a3626] text-[#faf7f2] rounded-full px-5 py-2.5 text-[13px] font-medium hover:bg-[#12261b] transition-all duration-300 shadow-[0_6px_20px_rgba(26,54,38,0.18)] hover:-translate-y-0.5"
          >
            Shop Soon
            <span className="text-[#c5a059]">→</span>
          </a>
          <button
            data-testid={HEADER.mobileMenuBtn}
            onClick={() => setOpen((v) => !v)}
            className="md:hidden p-2 rounded-full text-[#1a3626] hover:bg-[#1a3626]/5"
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-[#faf7f2]/98 backdrop-blur-xl border-t border-[#1a3626]/8">
          <div className="px-5 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <a
                key={n.id}
                data-testid={`${n.id}-mobile`}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-[#1a3626] text-base font-serif-display"
              >
                {n.label}
              </a>
            ))}
            <a
              href="/#signup"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center bg-[#1a3626] text-[#faf7f2] rounded-full px-5 py-3 text-sm font-medium"
            >
              Shop Soon →
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
